export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.6.11-0929.43",
  commitId: "54177f25568392e1027fb678d68dde5aadf0f076",
  commitTime: "2026-06-11T09:29:43.000Z",
});
